import { Injectable } from '@angular/core';
import { NL_ProgramAyarlari } from './../../models/NL_ProgramAyarlari';
import { Database } from './../database';
import 'rxjs/add/operator/map';

@Injectable()
export class BllProgramAyarlari extends Database{
    constructor()
    {
        super("NL_ProgramAyarlari");
    }
    YaziciAdiGuncelle(guncellenecekElement:NL_ProgramAyarlari){
        return new Promise((res,err)=>{
          this.execRawQueryWithParams("update NL_ProgramAyarlari set YaziciAdi = ? where ID = ?",[guncellenecekElement.BarkodYaziciAdi,guncellenecekElement.ID]).then(a=>{
            res(a);
          }).catch(x=>{
            err(x);
          })
        })
      }
    
    
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-programayarlari.ts